var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('a',{staticClass:"skip-link",attrs:{"href":"#main-content"}},[_vm._v("Перейти к содержимому")]),_c('site-header'),_c('main',{staticClass:"main",attrs:{"id":"main-content"}},[_c('router-view')],1),_c('site-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }